import { CommunityAdminModel } from '../models/CommunityAdmin.model';
import { CommunityAdminDTO } from '../dtos/CommunityAdmin.dto';
import { CommunityAdminRequestDTO } from '../infra/types';

export class CommunityAdminUtil {
  public static mapToViewModel(dto: CommunityAdminDTO): CommunityAdminModel {
    return {
      id: dto.memberId,
      userId: dto.userId,
      communityId: dto.communityId,
      community: dto.community.name,
      communityStatus: dto.community.status,
      appVersion: dto.community.appVersion,
      logo: dto.community.logo ? dto.community.logo : null,
      fullName: dto.userDetails.fullName,
      email: dto.userDetails.email,
      username: dto.userDetails.username,
      lastLogin: dto.userDetails.lastLogin ? dto.userDetails.lastLogin : null,
      isDeleted: dto.userDetails.isDeleted ? dto.userDetails.isDeleted : false,
      isVerified: dto.userDetails.isEmailVerified
        ? dto.userDetails.isEmailVerified
        : false,
      status: dto.status,
    };
  }

  public static toRequestDTO(
    model?: CommunityAdminModel,
  ): CommunityAdminRequestDTO {
    return {
      id: model ? model.id : undefined,
      communityId: model ? model.communityId : '',
      email: model ? model.email : '',
      username: model ? model.username : '',
      firstName: model ? model.fullName.split(' ')[0] : '',
      lastName: model ? model.fullName.split(' ')[1] : '',
      password: '',
      password_confirmation: '',
    };
  }
}
